import React, { useState, useEffect, useRef } from "react";
import { User, LogOut, Key, Menu } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Navbar = ({ isLoginPage = false, onToggleSidebar }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const userEmail = localStorage.getItem("adminEmail") || "admin@example.com";
  const userName = userEmail.split("@")[0];

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminEmail");
    setIsDropdownOpen(false);
    navigate("/adminpanel", { replace: true });
    window.location.reload();
  };

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header
      className={`fixed top-0 ${
        isLoginPage ? "left-0 w-full" : "left-64 right-0"
      } h-16 bg-white shadow flex items-center justify-between px-6 z-30`}
    >
      {/* Left Section */}
      <div className="flex items-center gap-4">
        {!isLoginPage && (
          <button
            onClick={onToggleSidebar}
            className="md:hidden p-2 rounded hover:bg-gray-100"
          >
            <Menu size={22} />
          </button>
        )}
        <h1 className="text-xl font-bold text-purple-700">
          {isLoginPage ? "Admin Login" : "Admin Panel"}
        </h1>
      </div>

      {/* Right Section (Only in Dashboard) */}
      {!isLoginPage && (
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className="flex items-center gap-2 rounded-full px-3 py-1.5 hover:bg-gray-100"
            aria-label="User menu"
          >
            <span className="font-medium hidden sm:inline">{userName}</span>
            <div className="w-9 h-9 flex items-center justify-center rounded-full bg-purple-100 text-purple-600">
              <User size={22} />
            </div>
          </button>

          {isDropdownOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-md border z-50">
              <div className="px-4 py-2 border-b">
                <p className="font-semibold">Hello, {userName}</p>
                <p className="text-sm text-gray-500">{userEmail}</p>
              </div>
              <div className="flex flex-col p-2">
                <button
                  onClick={() => console.log("Reset Password")}
                  className="flex items-center gap-2 px-3 py-2 hover:bg-gray-100 rounded"
                >
                  <Key size={16} /> Reset Password
                </button>
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-2 px-3 py-2 hover:bg-gray-100 rounded text-red-600"
                >
                  <LogOut size={16} /> Logout
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </header>
  );
};

export default Navbar;
